import { Device } from './device';
import { DeviceMeasurement } from './device-measurement';
import { Asset } from './asset';
import { AssetMeasurement } from './asset-measurement';
import { TriggerRule } from './trigger-rule';

export class Trigger {
  name: string;
  entityType: string;
  expression: string;
  type: string;
  creationAt: number;
  ownerUuid: string;
  device: Device;
  deviceMeasurement: DeviceMeasurement;
  asset: Asset;
  assetMeasurement: AssetMeasurement;
  triggerRule: TriggerRule;
  active: boolean;
  lastEvaluation: string;
  triggeredDate: number;
  lastValueEvaluated: string;
  evaluationDate: number;
  category: 'ALARM' | 'WARNING';
  disabledRepeatedEvents: boolean;
}
